"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const chartContext_1 = __importDefault(require("./chartContext"));
const chartReducer_1 = __importDefault(require("./chartReducer"));
const ChartState = ({ children }) => {
    const initialState = {
        chartTitle: "",
        chartLabels: [],
        chartDataList: [],
        chartCategory: "",
        comparePossible: false,
        setChartsData: {},
        getChartsData: {},
        removeChartsData: {},
        setComparePossible: {},
        removeChartsDataByLabel: {},
    };
    const [state, dispatch] = (0, react_1.useReducer)(chartReducer_1.default, initialState);
    const getChartsData = (title, label, dataList, category) => {
        dispatch({
            type: "GET_CHART_DATA_LIST",
            payload: {
                title,
                label,
                dataList,
                category,
            },
        });
    };
    const setChartsData = (title, label, dataValue, category) => {
        dispatch({
            type: "GET_CHART_DATA_LIST",
            payload: {
                title,
                label,
                dataValue,
                category,
            },
        });
    };
    const removeChartsData = () => {
        dispatch({ type: "REMOVE_CHART_DATA_LIST", payload: initialState });
    };
    const removeChartsDataByLabel = (labelToRemove) => {
        dispatch({
            type: "REMOVE_CHART_DATA_ELEMENT_BY_LABEL",
            payload: labelToRemove,
        });
    };
    const setComparePossible = (possible) => {
        dispatch({
            type: "SET_COMPARE_POSSIBLE",
            payload: possible,
        });
    };
    return (react_1.default.createElement(chartContext_1.default.Provider, { value: {
            chartTitle: state.chartTitle,
            chartLabels: state.chartLabels,
            chartDataList: state.chartDataList,
            chartCategory: state.chartCategory,
            comparePossible: state.comparePossible,
            setChartsData,
            getChartsData,
            removeChartsData,
            setComparePossible,
            removeChartsDataByLabel,
        } }, children));
};
exports.default = ChartState;
